import axios, { type AxiosError } from "axios";
import type { ResponseReadAll } from "epsm-api-types";
import type { PriceDaily } from "epsm-api-types/models";
import ErrorHandler from "@/services/ErrorService/ErrorService";

export async function makeRequest(
	requestFn: (options: any) => Promise<ResponseReadAll<any>>,
	requestOptions: any,
	stocksPrepared: PriceDaily[],
	setError: React.Dispatch<React.SetStateAction<AxiosError | null>>,
) {
	try {
		const res = await requestFn(requestOptions);
		stocksPrepared.push(...(res.data || []));
	} catch (e: unknown) {
		if (axios.isAxiosError(e)) {
			if (e.code === "ERR_CANCELED") return;

			ErrorHandler.logError(e);
			setError(e);
		}
	}
}
